/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Alarms_Form_Rule_Operator_EqInputs */



/**
* | output |
* | --- |
* | "equal to" |
*
* @param {Alarms_Form_Rule_Operator_EqInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const alarms_form_rule_operator_eq = /** @type {((inputs?: Alarms_Form_Rule_Operator_EqInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Alarms_Form_Rule_Operator_EqInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("equal to")
	return /** @type {LocalizedString} */ ("égale à")
});